export default {
  formId: 'estadisticasMensualForm',
  formField: {
    nombre_cliente: {
      name: 'nombre_cliente',
      label: 'Cliente',
      requiredErrorMsg: 'El cliente es requerido',
    },
    startDate: {
      name: 'startDate',
      label: 'Mes/Año Inicial',
      requiredErrorMsg: 'La fecha inicial es requerida',
    },
    endDate: {
      name: 'endDate',
      label: 'Mes/Año Final',
      requiredErrorMsg: 'La fecha final es requerida',
    },
  },
};
